import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { l10n } from '@ott/l10n';
import Button from '@ott/button';
import Modal, { modalIcons } from '@ott/modal';
import formatMoney from '@ott/utility-format-money';
import { selectors as virtualCardSelectors } from '@ott/shared-virtual-card-logic';
import { ErrorMessages } from '../../types';

import styles from './LimitsModal.scss';

const { ModalWarningIcon } = modalIcons;

const modalContentOptions = {
  className: styles.content,
  childrenClassNames: {
    closer: styles.closer,
  },
  withoutPadding: true,
};

type Props = {
  isOpen: boolean;
  onClose: VoidFunction;
  type: ErrorMessages;
};

const LimitsModal: FC<Props> = ({ isOpen, onClose, type }) => {
  const { data } = useSelector(virtualCardSelectors.getCardInfo);
  const { limits, currency: currencyCode = '' } = data || {};

  return (
    <Modal
      isOpen={isOpen}
      contentOptions={{
        ...modalContentOptions,
        icon: <ModalWarningIcon />,
        title: l10n(`virtualCard.errors.${type}.title`),
        footerContentNode: (
          <Button purpose="neutral" withFullWidth={true} onClick={onClose}>
            {l10n(`virtualCard.errors.${type}.action`)}
          </Button>
        ),
      }}
      onClose={onClose}
      specificLocators="limits-modal"
    >
      <div className={styles.description} data-locator="limits-description">
        {l10n(`virtualCard.errors.${type}.description`, {
          monthLimit: formatMoney(limits?.month || 0, {
            currencyCode,
          }),
          operationLimit: formatMoney(limits?.operation || 0, {
            currencyCode,
          }),
        })}
      </div>
    </Modal>
  );
};

export default LimitsModal;
